"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ReviewDetailsComponent = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ramda = require("ramda");

var _services = require("@alycecom/services");

var _query = require("@reduxjs/toolkit/query");

var _SendReview = _interopRequireDefault(require("../../components/SendReview/SendReview"));

var _gift = require("../../store/gift/gift.selector");

var paymentError = (0, _ramda.propOr)('', 'payment');
var recipientError = (0, _ramda.propOr)('', 'recipient');

var ReviewDetailsComponent = function ReviewDetailsComponent(_ref) {
  var disabled = _ref.disabled,
      profileName = _ref.profileName;
  var gift = (0, _reactRedux.useSelector)(_gift.getGift);
  var errors = (0, _reactRedux.useSelector)(_gift.getGiftErrors);
  var isAlyceGiftCard = (0, _reactRedux.useSelector)(_gift.isAlyceGiftCardSelector);

  var _useGetCampaignByIdQu = (0, _services.useGetCampaignByIdQuery)(gift.campaign_id || _query.skipToken),
      campaign = _useGetCampaignByIdQu.data;

  var remainingCampaignInvitations = gift && campaign ? campaign.giftsLimit : null;
  var purchaseError = (0, _react.useMemo)(function () {
    if (recipientError(errors)) {
      return errors.recipient;
    }

    if (paymentError(errors)) {
      return errors.payment;
    }

    return '';
  }, [errors]);
  return /*#__PURE__*/_react.default.createElement(_SendReview.default, {
    profileName: profileName,
    disabled: disabled,
    remainingInvites: remainingCampaignInvitations,
    recipientLandingPage: gift.recipient_landing_page,
    error: purchaseError,
    isAlyceGiftCard: isAlyceGiftCard
  });
};

exports.ReviewDetailsComponent = ReviewDetailsComponent;
ReviewDetailsComponent.propTypes = {
  profileName: _propTypes.default.string.isRequired,
  disabled: _propTypes.default.bool.isRequired
};

var _default = /*#__PURE__*/(0, _react.memo)(ReviewDetailsComponent);

exports.default = _default;